import { InjectionToken } from '@angular/core';

var MatchingStrategy;
(function (MatchingStrategy) {
    MatchingStrategy[MatchingStrategy["Contains"] = 0] = "Contains";
    MatchingStrategy[MatchingStrategy["StartsWith"] = 1] = "StartsWith";
    MatchingStrategy[MatchingStrategy["EndsWith"] = 2] = "EndsWith";
})(MatchingStrategy || (MatchingStrategy = {}));
const TypeAheadModuleConfigToken = new InjectionToken('type_ahead_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { MatchingStrategy, TypeAheadModuleConfigToken };

//# sourceMappingURL=mt-ng2-type-ahead-control-config.js.map